import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPostPageNew from "../../components/Post/ViewPostPageNew";



const RejectViewPostPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Reject Post" link2="/rejectpost" title="View Post" />

        {/* AddUserLayer */}
        <ViewPostPageNew />


      </MasterLayout>
    </>
  );
};

export default RejectViewPostPage;
